import ProgressLoading from './ProgressLoading';
export default ProgressLoading;